import React from 'react';
import {CLFBDetalleHistoria} from "../types/types";
import {ITableColumn, TableColumnType, TableList} from "../../../../../components/table";
import {OperacionCLFBDetalleFields, OperacionCLFBDetalleHistoriaFields} from "../types/fields";
import {QueryStatus} from "../../../../../types";

interface SeccionClfbDetalleHistoriaTablaProps {
  detalles: CLFBDetalleHistoria[]
}

function SeccionClfbDetalleHistoriaTabla({detalles}: SeccionClfbDetalleHistoriaTablaProps) {

  const columnsTablaCLFBDetalle: ITableColumn[] = [
    { label: 'Activo Tipo', value: OperacionCLFBDetalleFields.DescOperacionActivoTipo },
    { label: 'Límite Neto', value: OperacionCLFBDetalleFields.CreditLimitNeto, type: TableColumnType.Decimal },
    { label: 'Límite Absoluto', value: OperacionCLFBDetalleFields.CreditLimitAbsoluto, type: TableColumnType.Decimal },
    { label: 'Concentracion Máxima', value: OperacionCLFBDetalleFields.CreditLimitConcentracionMaxima, type: TableColumnType.Decimal },
    { label: 'Verde', value: OperacionCLFBDetalleFields.StopLossRoja },
    { label: 'Amarilla', value: OperacionCLFBDetalleFields.StopLossAmarilla },
    { label: 'Roja', value: OperacionCLFBDetalleFields.StopLossVerde },
    { label: 'Verde', value: OperacionCLFBDetalleFields.HoldingPeriodVerde },
    { label: 'Amarilla', value: OperacionCLFBDetalleFields.HoldingPeriodAmarilla },
    { label: 'Roja', value: OperacionCLFBDetalleFields.HoldingPeriodRoja },
    { label: 'Usuario Ant.', value: OperacionCLFBDetalleHistoriaFields.User},
    { label: 'Usuario Modificación.', value: OperacionCLFBDetalleHistoriaFields.LastUpdateUser},
    { label: 'Etapa Modificación', value: OperacionCLFBDetalleHistoriaFields.LastUpdateStage},
    { label: 'Fecha Modificación', value: OperacionCLFBDetalleHistoriaFields.LastUpdateDate,
      onRenderCell: (detalle: CLFBDetalleHistoria) => <span>{new Date(detalle[OperacionCLFBDetalleHistoriaFields.LastUpdateDate]).toLocaleString()}</span>},
    ]


  return (
    <div>
      <TableList
        entityList={detalles}
        columns={columnsTablaCLFBDetalle}
        error={false}
        isLoading={false}
      />
    </div>
  );
}

export default SeccionClfbDetalleHistoriaTabla;